import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import Spinner from "../../components/Reusable/Spinner";

const DashboardComponent = loadable(() => import("../../components/Dashboard"));

export default () => {
  const { data, isLoading } = useGetHook({
    url: APIS.OVERVIEW,
    queryKey: ["overview"],
    params: {},
  });
  const { data: cardData, isLoading: isCardDataLoading } = useGetHook({
    url: `${APIS.BILL}total-overview/`,
    params: {},
    queryKey: ["total-overview"],
  });
  return (
    <>
      {isLoading || isCardDataLoading ? (
        <Spinner />
      ) : (
        <DashboardComponent data={data} cardData={cardData} />
      )}
    </>
  );
};
